import { getContext, setContext } from 'svelte';
let groupKey = Symbol('group');
export function setGroupContext(ctx) {
    setContext(groupKey, ctx);
}
export function getGroupContext() {
    return getContext(groupKey);
}
